import { createProvider } from '@nvision/services/data-provider';

import type { PortTypeFilters } from '../../models';
import * as api from './api';
import { normalizePortTypeFilters, normalizePortTypes } from './normalize';

export const fetchPortTypes = createProvider(
  (filters: Partial<PortTypeFilters>, { signal }: { signal?: AbortController['signal'] } = {}) =>
    api.fetchPortTypes(normalizePortTypeFilters(filters), { signal }),
).andThen((res) => normalizePortTypes(res));
